import React from 'react';
import classnames from 'classnames';
import { translate } from 'constants/language';
import TransTableRow from './TransTableRow';

export default ({ wrapperClasses, creditHistory }) => {
  return (
    <div className={classnames(wrapperClasses)}>
      <TransTableRow
        transDetails={{
          type: `${translate('Order No')} :`,
          date: translate('Date'),
          charge: translate('Change'),
          balance: translate('Balance')
        }}
        isHead={true}
      />
      {creditHistory.map((creditTransaction, index) => {
        return (
          <TransTableRow
            creditTransaction={creditTransaction}
            transDetails={{
              type: `${creditTransaction.orderId || ''}`,
              date: creditTransaction.date,
              charge: creditTransaction.amount,
              balance: creditTransaction.balance,
              isCredit: creditTransaction.isCredit
            }}
            wrapperClasses={`${index % 2 === 0 ? 'bg-light-gray' : ''}`}
          />
        );
      })}
    </div>
  );
};
